import { EngineService } from '@/services/engine';
import type { ReportEventThumbnailFrame } from '@/types/report';

function sameThumbnailFrame(
    left: ReportEventThumbnailFrame,
    right: ReportEventThumbnailFrame,
): boolean {
    return (
        left.time === right.time &&
        left.bbox.every((value, index) => value === right.bbox[index])
    );
}

export function appendThumbnailFrame(
    thumbnails: ReportEventThumbnailFrame[],
    frame: ReportEventThumbnailFrame,
): ReportEventThumbnailFrame[] {
    return thumbnails.some((existing) => sameThumbnailFrame(existing, frame))
        ? thumbnails
        : [...thumbnails, frame];
}

export function thumbnailFrameUrl(
    sourceId: string,
    frame: ReportEventThumbnailFrame,
): string {
    return EngineService.buildSourceFrameThumbnailUrl(sourceId, {
        time: frame.time,
        bbox: frame.bbox,
    });
}
